import React from 'react'

import { Layout, Section } from '@/components/layout'

const pageId = 'referralTermsConditions'

export default function ReferralTermsConditions() {
  return (
    <Layout.Content padded>
      <Section paddingTop={32} responsive>
        <div className="max-w-700 policy-text">
          <p>After reading the terms below, you may close this page to return to the Neat app.</p>
          <p><em><strong>Referral Program Terms & Conditions:</strong> The referral bonuses will be distributed within 30 days of a referred customer beginning a Neat trial. If multiple customers refer the same person, the customer who referred first will receive the referral bonus. All referred customers will be tracked, and if they begin a trial, Neat will reach out to the user who submitted their email regarding the Amazon Gift Card. All gift cards will be virtually delivered via email within the 30-day period. Neat reserves the right to not contact submitted emails if there are suspicious circumstances, including fake emails and other problematic reasons. Customers can request additional emails to refer through our support channels, but Neat does not guarantee distribution. By agreeing to these terms, you also consent to receive emails from Neat regarding your referral bonuses.</em></p>
        </div>
      </Section>
    </Layout.Content>
  )
}

ReferralTermsConditions.layoutProps = {
  pageId,
  standalone: true,
}
